import { useContent } from "contexts/contentContext/contentContext";
import { useEffect, useRef } from "react";

import styles from "../styles.module.scss";

const useInviewAnimation = () => {
  const { getDirection } = useContent();
  const skipFirstRenderRef = useRef(true);

  const animationAppearStartName =
    getDirection() === "ltr" ? "animationAppearLeft" : "animationAppearRight";

  const animationAppearEndName =
    getDirection() === "ltr" ? "animationAppearRight" : "animationAppearLeft";

  useEffect(() => {
    setTimeout(() => {
      skipFirstRenderRef.current = false;
    }, 100);
  }, []);

  const inviewSettings = {
    threshold: 0.3,
    rootMargin: "100px",
    triggerOnce: true,
    skip: skipFirstRenderRef.current,
  };

  const animationDirectionENUM = {
    start: animationAppearStartName,
    end: animationAppearEndName,
    appear: "animationAppearIn",
  };

  const getFullClassName = (
    mainClass: string,
    animationDirection: "start" | "end" | "appear",
    condition: boolean
  ) => {
    return `${mainClass} ${
      condition ? styles[animationDirectionENUM[animationDirection]] : ""
    }`;
  };

  return { inviewSettings, getFullClassName };
};

export default useInviewAnimation;
